import { Injectable } from '@angular/core';
import { EntityUIQuery, QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ProjectUI } from './project-ui';
import { ProjectUploadStatus } from './project.model';
import { ProjectState, ProjectStore, ProjectUIState } from './project.store';

@Injectable({
  providedIn: 'root'
})
export class ProjectQuery extends QueryEntity<ProjectState> {

  ui: EntityUIQuery<ProjectUIState>;

  projects$ = this.selectAll();
  isLoading$ = this.selectLoading();
  activeNotNull$ = this.selectActive().pipe(filter(p => p !== null));
  active$ = this.selectActive();

  constructor(
    protected store: ProjectStore,
  ) {
    super(store);
    this.createUIQuery();
  }

  getUi(id: number): ProjectUI {
    return this.ui.getEntity(id);
  }

  selectUi(id: number): Observable<ProjectUI> {
    return this.ui.selectEntity(id);
  }

  selectUploadStatus(): Observable<ProjectUploadStatus> {
    return this.selectUi(this.getActiveId())
      .pipe(map(ui => ui.uploadStatus));
  }

}
